
import { z } from 'zod'
import { BaseEntitySchema } from './Common'
import { zodErrorParser } from '@/utils/zod'

export const NotificationTypes = [
  'DIGEST_INDIVIDUALS',
  'DIGEST_DELEGATES',
  'ALERT_COMMENT',
  'ALERT_STATUS_CHANGE',
  'ALERT_STATUS_TO_TAKEDOWN_FOR_INDIVIDUAL',
  'ALERT_ASSIGNMENT',
  'ALERT_UNASSIGNMENT',
  'ALERT_ESCALATION',
  'ALERT_UNESCALATION',
  'ALERT_PUBLIC_REPORT',
] as const

export type NotificationType = (typeof NotificationTypes)[number]

export const NotificationChannels = [
  'EMAIL',
  'PUSH',
] as const

const NotificationSettingResponseSchema = BaseEntitySchema.extend({
  id: z.uuid(),
  code: z.enum(NotificationTypes),
  channel: z.enum(NotificationChannels),
  enabled: z.boolean(),
  value: z.boolean()
}).strict()

const NotificationResponseSchema = z.object({
  id: z.uuid(),
  type: z.enum(NotificationTypes),
  readAt: z.string().nullish(),
  createdAt: z.string(),
  data: z.object({
    id: z.uuid(),
    title: z.string(),
    author: z.object({
      fullName: z.string()
    }).nullish(),
    comment: z.object({
      id: z.uuid(),
      content: z.string()
    }).nullish(),
    status: z.string().nullish(),
    assignedTo: z.object({
      fullName: z.string()
    }).nullish(),
    unassignedFrom: z.object({
      fullName: z.string()
    }).nullish(),
    escalatedTo: z.object({
      fullName: z.string()
    }).nullish(),
    deescalatedFrom: z.object({
      fullName: z.string()
    }).nullish(),
  }),
}).strict()

export type NotificationSettingResponse = z.infer<typeof NotificationSettingResponseSchema>
export type NotificationResponse = z.infer<typeof NotificationResponseSchema>

export const zodNotificationSettingResponseValidator = (
  data: NotificationSettingResponse[]
) => zodErrorParser(
  'NotificationSettingResponse',
  NotificationSettingResponseSchema,
  data,
)

export const zodNotificationResponseValidator = (
  data: NotificationResponse[]
) => zodErrorParser(
  'NotificationResponse',
  NotificationResponseSchema,
  data,
)
